module.exports = __webpack_public_path__ + "static/media/ss_4_en.93955496.jpg";